import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Fetch, hrLenseBaseUrl } from "../../../shared/Fetch";
import { Filter } from "../Filter";
import { Publish } from "../Publish";
import { Submission } from "./Submission";
import { IRecruiterRequirements } from "../../../models/RecruiterRequirements";
import { IModel2 } from "../sales/TableAll";
import { IReqFilter, EmptyFilter } from "../Filter";
import { Tag } from "primereact/tag";
import { ReqQuery } from "../ReqQuery";
import { Accordion, AccordionTab } from "primereact/accordion";
import { format } from "date-fns";
import { FloatReqSubmision } from "./FloatReqSubmision";
import { Dialog } from "primereact/dialog";
import { Table } from "../../consultantHotList/Table";
import { User } from "../../jvConnect/User";
import { Client_Type, Req_Term } from "../../../models/RequirementMast";
import { LegalTaskForm } from "../LegalTask";

interface Iprops {
    toast: any,
    permissions: IPermissionProps,
    reload: boolean,
    setReload: (is: boolean) => void,
    ShowCelebration: () => void
}

export const TableMy = (props: Iprops) => {
    const [tableMyData, setTableMyData] = useState({ tableData: [], loading: false } as { tableData: Array<IRecruiterRequirements>, loading: boolean });
    const [reqFilter, setReqFilter] = useState<IReqFilter>(EmptyFilter);
    const [floatReqSubModal, setFloatReqSubModal] = useState<boolean>(false);
    const [consultantListModal, setConsultantListModal] = useState({ open: false, singleData: {}, req_ID: 0 } as { open: boolean, singleData: any, req_ID: number });
    const [openLegalTask, setOpenLegalTask] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IRecruiterRequirements });
    const dt = useRef<any>(null);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };
    // const [filter, setFilter] = useState(false);
    // const hideFilterDialog = () => {
    //     setFilter(false);
    // };
    // const [userModal, setUserModal] = useState({ open: false, data: null as any });
    // const [userModalData, setUserModalData] = useState({ data: null as { employeeId?: number, empCode?: string, phoneNumber?: string, whatsAppNumber?: string, personalEmail?: string } | null });
    const [submission, setSubmission] = useState({ singleData: {}, open: false } as IModel2);
    const hideSubmissionDialog = () => {
        setSubmission({ singleData: {}, open: false });
    };
    const [query, setQuery] = useState({ req_id: 0, open: false } as { req_id: number, open: boolean });
    const hideQueryDialog = () => {
        setQuery({ req_id: 0, open: false });
    };

    useEffect(() => {
        loadTableData();
    }, [reqFilter, props.reload]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableMyData({ tableData: tableMyData.tableData, loading: true });
        const response = await Fetch("Requirement_MAST", "GET", null, `filter=` + encodeURIComponent(JSON.stringify(reqFilter)) + `&tb=${2}`, props.toast);
        if (response) {
            const data: Array<IRecruiterRequirements> = await response.json();
            setTableMyData({ tableData: data, loading: false });
        } else setTableMyData({ tableData: tableMyData.tableData, loading: false });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => props.setReload(!props.reload)} />
                {_roles.includes(4) && <Button label="Floated Req Submission" className="p-button-info ml-2" onClick={() => setFloatReqSubModal(true)} />}
                {(!_roles.includes(4)) && _roles.includes(3) && <Button label="Floated Req Submission" className="p-button-info ml-2" onClick={() => setFloatReqSubModal(true)} />}
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">My Requirements</h5>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
        </div>
    );

    const m_req_ID = (rowData: IRecruiterRequirements) => {
        return ((props.permissions.is_Create && !rowData.hold) && (rowData?.referred_By === null || rowData?.referred_By === 0) ?
            <span onClick={() => setSubmission({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.req_ID}
            </span>
            : <span>{rowData.req_ID}</span>);
    };
    const m_req_Job_Title = (rowData: IRecruiterRequirements) => {
        return rowData.req_EditedBy ? <span onClick={() => setPublish({ singleData: rowData, open: true })}
            className="cursor-pointer underline">
            <Tag severity="warning" value={rowData.req_Job_Title} />
        </span> : <span onClick={() => setPublish({ singleData: rowData, open: true })}
            className="cursor-pointer text-cyan-700 underline">
            {rowData.req_Job_Title}
        </span>;
    };
    const actionBodyTemplate = (rowData: IRecruiterRequirements) => {
        return <>
            <Button icon="pi pi-question-circle" label="Query" className="p-button-rounded p-button-text" onClick={() => { if (rowData.req_ID) setQuery({ open: true, req_id: rowData.req_ID }) }} />
            <Button label="V&QS" tooltip="Quick Submission" className="p-button-rounded p-button-text" onClick={() => {
                if (rowData.req_ID) {
                    let newData = {
                        req_ID: rowData.req_ID,
                        req_Job_Title: rowData.req_Job_Title,
                        req_Duration: rowData.req_Duration,
                        location: rowData.location,
                        rate: rowData.rate,
                        req_Term: rowData.req_Term,
                        client: rowData.client,
                        user_Name: rowData.user_Name,
                        litency: rowData.litency,
                        req_CategoryName: rowData.req_CategoryName,
                        hold: rowData.hold,
                        req_EditedBy: rowData.req_EditedBy,
                        req_RequiredSkill: rowData.req_RequiredSkill,
                        max_Submission: rowData.max_Submission,
                        sales_Branch: rowData.sales_Branch,
                        rec_Branch: rowData.rec_Branch,
                        referred_By: rowData.referred_By,
                    };
                    setConsultantListModal({ open: true, singleData: newData, req_ID: rowData.req_ID });
                }
            }} />
        </>
    };

    const onHideFloatSubModal = () => {
        setFloatReqSubModal(false);
    };

    const onHideConsultantListModal = () => {
        setConsultantListModal({ open: false, singleData: {}, req_ID: 0 });
    };

    // const rowClass = (data: any) => {
    //     return {
    //         'bg-orange-100 font-semibold': data.reqType_ID === 1,
    //     };
    // };

    // const getEmployeeDetails = async (empCode: string) => {
    //     const response = await fetch(`${hrLenseBaseUrl}/Tds_Slab/getempbycode?empCode=${empCode}`, { method: "GET" });
    //     if (response) {
    //         const data: { employeeId?: number, empCode?: string, phoneNumber?: string, whatsAppNumber?: string, personalEmail?: string } = await response.json();
    //         setUserModalData({ data });
    //     }
    // }

    const rowClass = (data: any) => {
        if (data.client_Type === Client_Type.Implementing_Partner) {
            return 'bg-pink-100 font-semibold';
        }
        else if (data.category) {
            return 'bg-indigo-200 font-semibold';
        }
        else if (data.reqType_ID === 1) {
            return 'bg-orange-100 font-semibold';
        } else {
            return ''; // default
        }
    }

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter reqFilter={reqFilter} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={2} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableMyData.tableData} emptyMessage="No Requirements found."
                header={header} loading={tableMyData.loading}
                rowClassName={rowClass}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="req_ID" header="Req.ID" sortable body={m_req_ID} />
                <Column field="req_Job_Title" sortable header="Job Title" body={m_req_Job_Title} />
                {/* <Column field="user_Name" sortable header="Sales Manager" /> */}
                {/* <Column header="Sales Manager" sortable body={(rowData: any) =>
                    //  (
                    //     <span className="text-cyan-700 underline cursor-pointer" onClick={() => {
                    //         if (rowData.user_Name.trim().split("-")[1].trim() !== '0') {
                    //             setUserModal({ open: true, data: { user_Name: rowData.user_Name.trim().split("-")[0], sales_Email: rowData.sales_Email, empCode: rowData.user_Name.trim().split("-")[1] } })
                    //             getEmployeeDetails(rowData.user_Name.trim().split("-")[1]);
                    //         }
                    //     }} >
                    //         {rowData.user_Name.split("-")[0]}
                    //     </span>
                    // )
                    <User req={rowData} show={true} />
                }
                /> */}

                <Column field="user_Name" sortable header="Sales Manager"
                    body={(r: IRecruiterRequirements) => <User req={{
                        reqId: r.req_ID ?? '',
                        jobTitle: r.req_Job_Title ?? '',
                        postedDate: r.pDate ?? '',
                        userId: r.req_PostedBySalesManager ?? 0,
                        userName: r.user_Name ?? '',
                    }} show={true}
                    />} />
                <Column field="" sortable header="Sales Comp (Branch)" body={(rowData: any) => <p>{`${rowData.salesComp?.includes("Talent") ? (rowData.salesComp?.split(" ")[0] + " " + rowData.salesComp?.split(" ")[1]) : rowData.salesComp?.split(" ")[0]} (${rowData.salesBranch})`}</p>} />
                <Column field="req_Duration" header="Duration" />
                <Column field="location" header="Location" />
                <Column field="rate" header="Rate" />
                <Column field="req_Term" header="Term" body={(rowData: IRecruiterRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                <Column field="req_CategoryName" header="Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable />
                <Column field="req_Sub_CategoryName" header="Sub Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable />
                <Column field="client" sortable header="Client" />
                <Column field="special_Constraint" header="Special Constraint" />
                <Column field="litency" header="Latency" />
                <Column field="req_RequiredSkill" header="Req Keyword" />
                <Column field="hold" header="Status" body={(rowData: IRecruiterRequirements) => rowData.hold ? "Hold" : "Unhold"} />
                <Column field="max_Submission" header="Max Submission" />
                <Column body={actionBodyTemplate} header="Action" />
                <Column header="Legal Task" body={(rowData: IRecruiterRequirements) => <Button className="p-button-rounded p-button-info p-button-text" onClick={() => setOpenLegalTask({ open: true, singleData: rowData })}>Task</Button>} />
            </DataTable>
            {/* <Dialog visible={userModal.open} onHide={() => {
                setUserModal({ open: false, data: null });
                setUserModalData({ data: null });
            }} header="Sales Manager Details" modal style={{ width: "30vw" }} >
                {userModal.data && (
                    <div className="p-fluid">
                        <div className="border-round surface-card p-4 shadow-2">
                            <div className="flex align-items-center mb-4"> <i className="pi pi-user text-primary text-xl mr-3" /> <div>
                                <div className="text-900 font-semibold text-lg">
                                    {userModal.data.user_Name}
                                </div>
                                <div className="text-600 text-sm"> Sales Manager </div>
                            </div>
                            </div>
                            <div className="grid">
                                {userModalData?.data?.personalEmail && <div className="col-12 flex align-items-center mb-3">
                                    <i className="pi pi-envelope text-primary mr-3" />
                                    <div>
                                        <div className="text-600 text-sm">Professional Email</div>
                                        <div className="text-900 font-medium"> {userModal?.data?.sales_Email} </div>
                                    </div>
                                </div>}
                                {userModalData?.data?.personalEmail && <div className="col-12 flex align-items-center mb-3">
                                    <i className="pi pi-envelope text-primary mr-3" />
                                    <div>
                                        <div className="text-600 text-sm">Email/Hangout</div>
                                        <div className="text-900 font-medium"> {userModalData?.data?.personalEmail} </div>
                                    </div>
                                </div>}
                                {userModalData?.data?.phoneNumber && <div className="col-12 flex align-items-center mb-3">
                                    <i className="pi pi-phone text-primary mr-3" />
                                    <div>
                                        <div className="text-600 text-sm">Phone</div>
                                        <div className="text-900 font-medium"> {userModalData?.data?.phoneNumber} </div>
                                    </div>
                                </div>}
                                {userModalData?.data?.whatsAppNumber && <div className="col-12 flex align-items-center mb-3">
                                    <i className="pi pi-phone text-primary mr-3" />
                                    <div>
                                        <div className="text-600 text-sm">WhatsApp</div>
                                        <div className="text-900 font-medium"> {userModalData?.data?.whatsAppNumber} </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>

                )}
            </Dialog> */}
            {/* <Filter hideDialog={hideFilterDialog} open={filter} toast={props.toast} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={2} /> */}
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
            <ReqQuery open={query.open} req_id={query.req_id} hideDialog={hideQueryDialog} toast={props.toast} />
            <Submission singleData={submission.singleData} open={submission.open} hideDialog={hideSubmissionDialog} toast={props.toast} ShowCelebration={props.ShowCelebration} />
            <Dialog visible={floatReqSubModal} style={{ width: '80vw' }} header="Float Req Submission" className="p-fluid" maximizable onHide={onHideFloatSubModal}>
                <FloatReqSubmision open={floatReqSubModal} toast={props.toast} hideDialog={onHideFloatSubModal} />
            </Dialog>
            <Dialog visible={consultantListModal.open} style={{ width: '80vw' }} header="Consultant List" className="p-fluid" maximizable onHide={onHideConsultantListModal}>
                <Table isQuickSubmission={true} toast={props.toast} setModal={(modal: { singleData: any, open: boolean }) => { }} reqDetails={consultantListModal.singleData} reload={true} />
            </Dialog>
            <LegalTaskForm open={openLegalTask.open} singleData={openLegalTask.singleData} req_ID={openLegalTask?.singleData?.req_ID || 0} hideDialog={() => setOpenLegalTask({ open: false, singleData: {} })} toast={props.toast} />
        </>
    );
}
